import React from "react";
import Ripple from "../../../../../../../dumb/Ripple";
import {apiV2KycDocumentGet} from "../../../../../../../../api/admin/retailersCreate";
import {default as CircularProgress} from "@material-ui/core/CircularProgress";
import {API_URL_HTTP} from "../../../../../../../../config/api";

export default ({id, file_name}) => {
  const [loading, setLoadingState] = React.useState(false);
  return (
    <Ripple
      className="wmaxFitContent w layoutRow aiC pv8 ph19 bgFAFAFA b1 bs bc3E4044 r9"
      disabled={loading}
      onClick={() => {
        setLoadingState(true);

        apiV2KycDocumentGet({id})
          .then((response) => response.blob())
          .then((blob) => {
            const fileURL = URL.createObjectURL(blob);

            if (blob.type === 'application/pdf') {
              const link = document.createElement('a');
              // create a blobURI pointing to our Blob
              link.href = fileURL;
              link.download = file_name;
              // some browser needs the anchor to be in the doc
              document.body.append(link);
              link.click();
              link.remove();
            } else {
              window.open(fileURL, '_blank', 'popup');
            }

            URL.revokeObjectURL(fileURL);

          }).finally(() => setLoadingState(false));
      }}
    >
      <div className="w16 h16 layoutRow jcC aiC mr10 (dB)>svg">
        {loading
          ? (
            <CircularProgress size={13} className="(c0)>.MuiCircularProgress-svg" />
          ) : (
            <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5918 5.06405L8.23985 0.264139C8.16506 0.181267 8.07375 0.114965 7.97179 0.0694991C7.86984 0.0240327 7.7595 0.000407837 7.64786 0.000143978H2.04796C1.78217 -0.00302644 1.51835 0.0461912 1.27158 0.144986C1.0248 0.243782 0.799909 0.390219 0.609734 0.575937C0.41956 0.761654 0.26783 0.983014 0.163212 1.22738C0.0585926 1.47174 0.00313304 1.73431 0 2.00011V13.9999C0.00313304 14.2657 0.0585926 14.5283 0.163212 14.7726C0.26783 15.017 0.41956 15.2383 0.609734 15.4241C0.799909 15.6098 1.0248 15.7562 1.27158 15.855C1.51835 15.9538 1.78217 16.003 2.04796 15.9999H10.7518C11.0176 16.003 11.2814 15.9538 11.5282 15.855C11.775 15.7562 11.9999 15.6098 12.19 15.4241C12.3802 15.2383 12.5319 15.017 12.6366 14.7726C12.7412 14.5283 12.7966 14.2657 12.7998 13.9999V5.60004C12.7993 5.40178 12.7251 5.21077 12.5918 5.06405ZM10.9198 5.60004H7.76786C7.60294 5.5838 7.45099 5.50343 7.34476 5.37625C7.23852 5.24906 7.18649 5.08523 7.19987 4.92005V1.60012H7.28787L10.9198 5.60004ZM10.7518 14.3999H2.04796C1.99226 14.4031 1.93647 14.3953 1.88379 14.377C1.8311 14.3586 1.78256 14.33 1.74094 14.2929C1.69932 14.2557 1.66544 14.2107 1.64125 14.1604C1.61706 14.1102 1.60303 14.0556 1.59997 13.9999V2.00011C1.60303 1.9444 1.61706 1.88984 1.64125 1.83956C1.66544 1.78929 1.69932 1.74428 1.74094 1.70712C1.78256 1.66996 1.8311 1.64138 1.88379 1.62302C1.93647 1.60466 1.99226 1.59687 2.04796 1.60012H5.5999V4.92005C5.58699 5.50934 5.8077 6.07981 6.21386 6.50696C6.62003 6.93411 7.17867 7.18325 7.76786 7.20001H11.1998V13.9999C11.1967 14.0556 11.1827 14.1102 11.1585 14.1604C11.1343 14.2107 11.1004 14.2557 11.0588 14.2929C11.0172 14.33 10.9687 14.3586 10.916 14.377C10.8633 14.3953 10.8075 14.4031 10.7518 14.3999Z" fill="#3E4044"/>
            </svg>
          )
        }
      </div>
      <span className="dB tovEllipsis ovHidden wsNowrap">{file_name}</span>
    </Ripple>
  )
};
